module.exports = __webpack_public_path__ + "res/ic_login_rtl.9170a7f83ee0689d611e1e9354e6ff0f.png";